import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Directive({
  selector: '[WLTempBorder]',
  standalone: true,
})
export class WLTempBorderDirective {
  public border = environment.withBorder;
  private element = inject(ElementRef);
  private renderer = inject(Renderer2);
  @Input() set WLTempBorder(condition: boolean | undefined | '') {
    if (condition) {
      this.renderer.setStyle(
        this.element.nativeElement,
        'border',
        '1px solid grey'
      );
    } else if (this.border) {
      this.renderer.setStyle(
        this.element.nativeElement,
        'border',
        '1px solid grey'
      );
    }
  }
}
